import { type H3Event, getRequestHeaders } from 'h3'

import { getDefaultExperiments, getExperimentsFromHeaders } from '../utils'

const REQUEST_EXPERIMENTS_CONTEXT_KEY = '$experiments'

/**
 * Get all experiments for a request.
 *
 * The resolved dictionary is immutable and cached on the H3 event so all
 * server-side consumers (including the HTML-render hook) share it. It must
 * not be cached at module level: experiment assignments are request-specific.
 *
 * @example - Nitro
 * import { getRequestExperiments } from '@backmarket/nuxt-module-experiments/getRequestExperiments'
 * const experiments = getRequestExperiments(event)
 */
export function getRequestExperiments(event: H3Event): Record<string, string> {
  const cachedExperiments = event.context[REQUEST_EXPERIMENTS_CONTEXT_KEY] as
    | Record<string, string>
    | undefined

  if (cachedExperiments) return cachedExperiments

  const experiments = Object.freeze({
    ...getDefaultExperiments(),
    ...getExperimentsFromHeaders(getRequestHeaders(event)),
  })

  // eslint-disable-next-line no-param-reassign
  event.context[REQUEST_EXPERIMENTS_CONTEXT_KEY] = experiments

  return experiments
}
